import { ApolloError } from '@apollo/client';
/**
 * The error a resolved mutation result carries, or `undefined` when the mutation went through.
 * Apollo Client 3 puts it on `errors` as an `ApolloError` or a list; at the 4 bump only this body
 * changes. It takes a result rather than `unknown`, so passing an error by mistake does not compile.
 */
export const getMutationResultError = (result) => {
    const errors = result === null || result === void 0 ? void 0 : result.errors;
    if (Array.isArray(errors)) {
        return errors.length > 0 ? new ApolloError({ graphQLErrors: errors }) : undefined;
    }
    if (!errors) {
        return undefined;
    }
    if (errors instanceof ApolloError) {
        return errors;
    }
    // A shape Apollo never resolves with still counts as a failure, so a refused write is never
    // reported as saved.
    return new ApolloError({ networkError: errors instanceof Error ? errors : new Error(String(errors)) });
};
